export default __webpack_public_path__ + "static/media/stephen.56fabdb3.png";